import { useMemo } from 'react';
import { useFilesBase, FileListItem } from './use-files-base';

const dummyFiles: FileListItem[] = [
  { id: '1', name: 'Q4_Partnership_Agreement.pdf', size: '2.4 MB', date: 'Feb 25, 2026', source: 'email' },
  { id: '2', name: 'Product_Roadmap_2026.pptx', size: '8.1 MB', date: 'Feb 18, 2026', source: 'email' },
  { id: '3', name: 'Pricing_Sheet_v3.xlsx', size: '340 KB', date: 'Feb 10, 2026', source: 'email' },
];

interface UseAccountFilesOptions {
  skip?: boolean;
}

export const useAccountFiles = (accountId: string, options: UseAccountFilesOptions = {}) => {
  const entityFilter = useMemo(() => ({ accountId }), [accountId]);

  return useFilesBase({
    entityFilter,
    entityId: accountId,
    skip: options.skip,
    dummyFiles,
  });
};
